import { render, staticRenderFns } from "./MitMyFavoriteSpaces.vue?vue&type=template&id=0ffbc5ca&scoped=true"
import script from "./MitMyFavoriteSpaces.vue?vue&type=script&lang=js"
export * from "./MitMyFavoriteSpaces.vue?vue&type=script&lang=js"
import style0 from "./MitMyFavoriteSpaces.vue?vue&type=style&index=0&id=0ffbc5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbc5ca",
  null
  
)

export default component.exports